import { render, staticRenderFns } from "./booked-seats.vue?vue&type=template&id=f8508442&scoped=true"
import script from "./booked-seats.vue?vue&type=script&lang=js"
export * from "./booked-seats.vue?vue&type=script&lang=js"
import style0 from "./booked-seats.vue?vue&type=style&index=0&id=f8508442&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8508442",
  null
  
)

export default component.exports